// extracted by mini-css-extract-plugin
module.exports = {"header":"CustomerHeaderStyle_header__2cLHI","back_btn":"CustomerHeaderStyle_back_btn__3N8G_","header_logo":"CustomerHeaderStyle_header_logo__YYo2G"};